/*
 * - Exposes class and methods to interact with the JPA API
 */

import request, { REQUEST_METHODS } from '@api/Request';
import { RequestTypeStringsLookup } from '@src/utils/enums';
import { JpaEndpoints } from './config';
import {
  GetJpaDynamicTableRequest,
  GetJpaDynamicTableResponse,
  GetJpaFormRequest,
  GetJpaFormResponse,
  GetJpaInitialSectionRequest,
  GetJpaInitialSectionResponse,
  GetJpaOrgRequest,
  GetJpaOrgResponse,
  GetJpaDynamicTableAnswersRequest,
  GetJpaDynamicTableAnswersResponse,
} from './types';

export default class JpaService {
  public static readonly getDynamicTable = (params: GetJpaDynamicTableRequest): Promise<GetJpaDynamicTableResponse> =>
    request({
      url: JpaEndpoints.getDynamicTable(),
      method: REQUEST_METHODS.GET,
      params,
    });

  public static readonly getDynamicTableAnswers = (
    params: GetJpaDynamicTableAnswersRequest
  ): Promise<GetJpaDynamicTableAnswersResponse> =>
    request({
      url: JpaEndpoints.getDynamicTableAnswers(),
      method: REQUEST_METHODS.GET,
      params,
    });

  public static readonly getForm = (params: GetJpaFormRequest): Promise<GetJpaFormResponse> =>
    request({
      url: JpaEndpoints.getForm(),
      method: REQUEST_METHODS.GET,
      params,
    });

  public static readonly getInitialSection = (
    params: GetJpaInitialSectionRequest
  ): Promise<GetJpaInitialSectionResponse> =>
    request({
      url: JpaEndpoints.getInitialSection(),
      method: REQUEST_METHODS.GET,
      params,
    });

  public static readonly getOrgs = (data: GetJpaOrgRequest): Promise<GetJpaOrgResponse> =>
    request({
      url: JpaEndpoints.getOrgs(),
      method: REQUEST_METHODS.POST,
      data: {
        State: data?.state ?? null,
        District: data?.district ?? null,
        Geometry: data?.geometry || null,
        RequestType: RequestTypeStringsLookup[data?.requestType],
      },
    });
}
